import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import '@mantine/core/styles.css'
import '@mantine/tiptap/styles.css'
import '@mantine/dates/styles.css'
import './global-styles.module.scss'

import { ColorThemeProvider } from '../context/colorTheme/colorThemeContextController/ColorThemeContextController'

import { AppProviders } from '@percent/workplace-giving/providers/AppProviders'
import { AppRoutes } from '@percent/workplace-giving/routing/AppRoutes'
import { useHubSpotWidget } from '@percent/workplace-giving/common/hooks/useHubSpotWidget/useHubSpotWidget'
import { GenericError } from '@percent/workplace-giving/common/components/GenericError/GenericError'
import { EnvironmentOverlay } from '@percent/shared/environment-overlay'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export function UnconnectedApp() {
  const { t } = useTranslation()
  useEffect(() => {
    document.title = t('workplace_giving.head.title')
  }, [])
  useHubSpotWidget()

  return (
    <ColorThemeProvider>
      <AppProviders>
        <EnvironmentOverlay />
        <Sentry.ErrorBoundary fallback={<GenericError />}>
          <AppRoutes />
          <ScrollToTop />
        </Sentry.ErrorBoundary>
      </AppProviders>
    </ColorThemeProvider>
  )
}

export const App = UnconnectedApp
